/*
This options object is accepted by all actions of the api module.
It should be implemented by all new actions that are created.

isAuth - if the httpRequest action should check for an auth
token. This should not be overwritten by components and will
only ever be set by an action.

isCms - whether or not the CMS is active. We manually set this
rather than using the Vuex state (isCMS) because sometimes we
want to override it.

updateStoreFirst - whether to update the store before
writing to the backend. Optionally implemented by an action.
 */
export default function getDefaultOpts() {
  return {
    // These are implemented by httpRequest
    isAuth: true,
    isCms: true,
    // These are optionally implemented by an action
    updateStoreFirst: false,
    debounce: false,
  };
}
